export const checkDeviceOnResize = mobileDispatch => {
  window.addEventListener("resize", () => {
    if (window.innerWidth <= 450 || (window.screen.availWidth < 450 && window.screen.orientation.type === "portrait-primary")) {
      mobileDispatch("mobile");
    } else if (window.innerWidth > 450 && window.innerWidth <= 1024) {
      mobileDispatch("tablet");
    } else {
      mobileDispatch("desktop");
    }
  });
};



// WEBPACK FOOTER //
// ./src/util/watchScreenWidth.js